// const BASE_URL = process.env.REACT_APP_MAPBOX_API_URL;
const ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
const MAPBOX_API_URL = process.env.REACT_APP_MAPBOX_API_URL;

export const getStaticMapImageURL = (data) => {
  const { h = 720, w = 1280, lat, lon } = data;
  return `${MAPBOX_API_URL}/styles/v1/mapbox/streets-v12/static/pin-s+555555(${lon},${lat})/auto/${w}x${h}?access_token=${ACCESS_TOKEN}`;
};
